(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockKfzPostleitzahlFahrzeughalter', {
            require: {
                form: '^form'
            },
            bindings: {
                onChange: '&abkpfOnChange',
                options: '<abkpfOptions'
            },
            templateUrl: 'bloecke/kfz/postleitzahlFahrzeughalter/blockPostleitzahlFahrzeughalter.html',
            controller: BlockKfzPostleitzahlFahrzeughalterController,
            controllerAs: 'plzFahrzeughalterVm'
        });

    BlockKfzPostleitzahlFahrzeughalterController.$inject = [
        '$timeout',
        '$q',
        'lodash',
        'AngebotModel',
        'AngebotKfzService',
        'AngebotUtilsService',
        'MiscUtilsService',
        'LoadingIndicatorService',
        'BasisAngebotService'
    ];
    function BlockKfzPostleitzahlFahrzeughalterController($timeout, $q, _, AngebotModel, AngebotKfzService, AngebotUtilsService, MiscUtilsService, LoadingIndicatorService, BasisAngebotService) {
        var vm = this,
            ersatzgeschaeftAenderbarMap;

        vm.$onInit = onInit;

        vm.onPostleitzahlFahrzeughalterChanged = onPostleitzahlFahrzeughalterChanged;
        vm.getFahrzeughalterZbnUndOrt = getFahrzeughalterZbnUndOrt;
        vm.setFahrzeughalterZbnUndOrt = setFahrzeughalterZbnUndOrt;
        vm.getTextZbnOrt = getTextZbnOrt;
        vm.existsPlz = existsPlz;

        vm.isOrtFahrzeughalterErlaubt = isOrtFahrzeughalterErlaubt;
        vm.isPostleitzahlFahrzeughalterDisabled = isPostleitzahlFahrzeughalterDisabled;
        vm.isOrtFahrzeughalterDisabled = isOrtFahrzeughalterDisabled;
        vm.isTooltipErlaubt = isTooltipErlaubt;

        function activate() {
            vm.angebotModel = AngebotModel.get();
            vm.isPrivatPerson = BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot);
            vm.isChangeEvent = false;
            ersatzgeschaeftAenderbarMap = AngebotUtilsService.getErsatzgeschaeftDatenAenderbarMap(vm.angebotModel.angebot, vm.angebotModel.angebotInitial);
            vm.zulassungsbezirke = [];
            vm.getFahrzeughalterZbnUndOrt(_.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter'), false).catch(function (error) {});
            vm.labelPostleitzahl = _.get(vm.options, 'labelPostleitzahl') || 'Postleitzahl des Fahrzeughalters';
        }

        function onInit() {
            activate();
        }

        function onPostleitzahlFahrzeughalterChanged(postleitzahlFahrzeughalter) {
            vm.isChangeEvent = true;
            vm.zulassungsbezirke = [];

            getFahrzeughalterZbnUndOrt(postleitzahlFahrzeughalter, true).finally(function () {
                $timeout(function () {
                    vm.isChangeEvent = false;
                });
            });
        }
        function getFahrzeughalterZbnUndOrt(postleitzahl, isChangeEvent) {
            if (!AngebotKfzService.isPostleitzahlFahrzeughalterErlaubt(vm.angebotModel.angebot)) {
                return $q.resolve([]);
            }
            if (isChangeEvent) {
                setFahrzeughalterZbnUndOrt();
            }

            LoadingIndicatorService.addInProgress();

            return $q(function (resolve, reject) {
                AngebotKfzService.getZulassungsbezirke(vm.angebotModel, postleitzahl, false).then(function (zulassungsbezirke) {
                    resolve(zulassungsbezirke);

                    vm.zulassungsbezirke = zulassungsbezirke;

                    if (zulassungsbezirke.length === 1) {
                        setFahrzeughalterZbnUndOrt(zulassungsbezirke[0]);
                    }
                }).catch(function (error) {
                    reject(error);
                    vm.zulassungsbezirke = [];
                    setFahrzeughalterZbnUndOrt({});
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                });
            }).catch(function (error) {});
        }
        function setFahrzeughalterZbnUndOrt(zulassungsbezirk, zbnManuellGewaehlt) {
            if (!BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANGEBOT')) {
                return;
            }

            vm.angebotModel.formData.zbnManuellGewaehlt = !!zbnManuellGewaehlt;
            AngebotKfzService.setFahrzeughalterZbnUndOrt(vm.angebotModel.angebot, zulassungsbezirk);

            if (angular.isFunction(vm.onChange)) {
                vm.onChange({ zulassungsbezirk: zulassungsbezirk });
            }

            if (MiscUtilsService.isEmpty(zulassungsbezirk)) {
                _.set(vm.angebotModel.formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', null);
            } else {
                _.set(vm.angebotModel.formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', zulassungsbezirk);
            }
        }
        function getTextZbnOrt(zulassungsbezirk) {
            return AngebotKfzService.getTextZbnOrt(zulassungsbezirk, true);
        }
        function existsPlz(postleitzahl) {
            return $q(function (resolve, reject) {
                return AngebotKfzService.getZulassungsbezirke(vm.angebotModel, postleitzahl).then(function (zulassungsbezirke) {
                    resolve(zulassungsbezirke);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }

        function isOrtFahrzeughalterErlaubt() {
            return (
                MiscUtilsService.isNotEmpty(_.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter')) &&
                _.size(vm.zulassungsbezirke) > 0
            );
        }
        function isPostleitzahlFahrzeughalterDisabled() {
            return (
                _.get(ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter') === false ||
                _.get(vm.angebotModel.angebot, 'aenderbareTarifmerkmale.plzFahrzeughalter') === false ||
                _.get(vm.options, 'postleitzahlDisabled')
            );
        }
        function isOrtFahrzeughalterDisabled() {
            return (
                (
                    _.get(ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter') === false ||
                    _.get(vm.angebotModel.angebot, 'aenderbareTarifmerkmale.plzFahrzeughalter') === false
                ) &&
                MiscUtilsService.isNotEmpty(_.get(vm.angebotModel.angebotOriginal, 'angebotsgegenstandFahrzeug.zbn')) &&
                MiscUtilsService.isNotEmpty(_.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter'))
            ) || _.size(vm.zulassungsbezirke) === 1;
        }

        function isTooltipErlaubt() {
            return vm.options.showTooltip !== false;
        }

    }

})();
